import { useContext, useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PartnerEnrollmentFormContext from "./enrollment-form-context";
import AppProgressBar from "../../Common/progressBar";
import { clientConfig } from "../../awsClientConfig";
import { GetOrganization } from "../../queries/GetOrganization";
import { CreateOrganizationAddress } from "../../queries/CreateOrganizationAddress";
import { CreatePartnerEnrollementAction } from "../../queries/CreatePartnerEnrollementAction";
import { StateOptions } from "../../contants";
import { formatZipcode } from "../../functions/misc";
import Message from "../Message";
import { Spinner } from "react-bootstrap";
import { UpdateOrganizationAddress } from "../../queries/UpdateOrganizationAddress";
import { AnimatePresence, motion } from "framer-motion";
import { motionContainer } from "../organicClient";

type BUSINESS_ADDRESS = {
  streetAddress1: string;
  streetAddress2: string;
  zipCode: string;
  state: string;
  city: string;
};

const FORM_ERROR = {
  streetAddress1: "",
  // streetAddress2: "",
  zipCode: "",
  state: "",
  city: "",
};

const PartnerDefaultMailingAddress = ({ progressPercent = 0 }) => {
  const { next, organizationId, setOrganizationId, enrollmentId } = useContext(
    PartnerEnrollmentFormContext
  );
  const [formErrors, setFromErros] = useState(FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const [showSpinnerSubmit, setShowSpinnerSubmit] = useState(false);
  const [alternativeAddress, setAlternativeAddress] = useState(false);
  const [newAddress, setNewAddress] = useState(false);
  const client = new clientConfig();

  const [business, setBusiness] = useState({
    name: "",
    eni: "",
    type: "SoleProprietorship",
    phone: "",
  });
  const [addresses, setAddresses] = useState([{}]);
  const [businessAddress, setBusinessAddress] = useState({
    streetAddress1: "",
    streetAddress2: "",
    zipCode: "",
    state: "AL",
    city: "",
    id: "",
    types: [],
  });
  const [storeAddress, setStoreAddress] = useState({
    streetAddress1: "",
    streetAddress2: "",
    zipCode: "",
    state: "AL",
    city: "",
    id: "",
    types: [],
  });
  const [mailingAddress, setMailingAddress] = useState({
    streetAddress1: "",
    streetAddress2: "",
    zipCode: "",
    state: "AL",
    city: "",
    id: "",
    types: [],
  });

  const [isStoreFrontLocation, setIsStoreFrontLocation] =
    useState<boolean>(true);

  useEffect(() => {
    const validateForm = () => {
      const error = { ...formErrors };
      if (mailingAddress.streetAddress1) {
        error.streetAddress1 = "";
      } else {
        error.streetAddress1 = "Street Address can not be empty";
      }

      if (mailingAddress.city) {
        error.city = "";
      } else {
        error.city = "City can not be empty";
      }

      if (mailingAddress.state) {
        error.state = "";
      } else {
        error.state = "State can not be empty";
      }

      if (mailingAddress.zipCode) {
        error.zipCode = "";
      } else {
        error.zipCode = "ZIP Code can not be empty";
      }

      setFromErros(error);
    };
    validateForm();
  }, [mailingAddress]);
  useEffect(() => {
    if (organizationId) {
      client
        .query({
          query: GetOrganization,
          variables: { organizationId },
        })
        .then((res: any) => {
          const organizationData = res.data.GetOrganization;
          const organizationAddresses =
            res.data.GetOrganization.OrganizationAddresses;
          setShowSpinner(false);
          setNewAddress(true);
          const mainAddress = organizationAddresses?.find((address: any) => {
            return address.OrganizationAddressTypes?.some((addressTypes: any) => addressTypes.Type === "Main");
          });

          const storefrontAddress = organizationAddresses?.find((address: any) => {
            return address.OrganizationAddressTypes?.some((addressTypes: any) => addressTypes.Type === "Storefront");
          });

          setBusiness({
            eni: organizationData.Ein,
            name: organizationData.Name,
            phone: organizationData.Phone,
            type: organizationData.Type,
          });

          if (mainAddress) {
            setBusinessAddress({
              streetAddress1: mainAddress.StreetAddress1,
              streetAddress2: mainAddress.StreetAddress2,
              zipCode: mainAddress.ZipCode,
              state: mainAddress.State,
              city: mainAddress.City,
              id: mainAddress.Id,
              types: mainAddress.OrganizationAddressTypes,
            });
            setMailingAddress({
              streetAddress1: mainAddress.StreetAddress1,
              streetAddress2: mainAddress.StreetAddress2,
              zipCode: mainAddress.ZipCode,
              state: mainAddress.State,
              city: mainAddress.City,
              id: mainAddress.Id,
              types: mainAddress.OrganizationAddressTypes,
            });
          }
          if (storefrontAddress) {
            if (mainAddress?.Id !== storefrontAddress?.Id) {
              setStoreAddress({
                streetAddress1: storefrontAddress.StreetAddress1,
                streetAddress2: storefrontAddress.StreetAddress2,
                zipCode: storefrontAddress.ZipCode,
                state: storefrontAddress.State,
                city: storefrontAddress.City,
                id: storefrontAddress.Id,
                types: storefrontAddress.OrganizationAddressTypes,
              });
              setAddresses([mainAddress, storefrontAddress]);
              return;
            }
          }
          setAddresses(organizationAddresses);
        })
        .catch((error: any) => {
          console.log('error', error);
        });
    }
  }, [organizationId]);

  const onChangeAddress = (event: any) => {
    const newBusinessAddress = {
      ...mailingAddress,
      [event.target.name]:
        event.target.name != "zipCode"
          ? event.target.value
          : formatZipcode(event),
    };

    setMailingAddress(newBusinessAddress);
  };

  const onChangeUseAddress = (event: any) => {

    let type = event.target.value.split(' -')[0];

    switch (type) {
      case "Main":
        setMailingAddress(businessAddress);
        setAlternativeAddress(false);
        break;

      case "Storefront":
        setMailingAddress(storeAddress);
        setAlternativeAddress(false);
        break;

      case "Mailing":
        setAlternativeAddress(true);
        setMailingAddress({
          city: "",
          state: "AL",
          streetAddress1: "",
          streetAddress2: "",
          zipCode: "",
          id: "",
          types: []
        });
        break;

      default:
        setAlternativeAddress(false);
        return;
    }
  };

  const onSubmit = async () => {
    setShowSpinnerSubmit(true);
    setSubmited(true);
    const isAnyError = Object.values(formErrors).find((item) => Boolean(item));

    if (!isAnyError) {

      if (alternativeAddress) {
        client
          .query({
            query: GetOrganization,
            variables: { organizationId },
          })
          .then((res: any) => {
            const organizationAddresses = res.data.GetOrganization.OrganizationAddresses;
            const addressVariables: any = {
              City: mailingAddress.city,
              OrganizationId: organizationId,
              State: mailingAddress.state,
              StreetAddress1: mailingAddress.streetAddress1,
              OrganizationAddressTypes: [{
                Type: "Mailing"
              }],
              ZipCode: mailingAddress.zipCode,
            };

            if (mailingAddress.streetAddress2) {
              addressVariables.StreetAddress2 = mailingAddress.streetAddress2
            }

            const mailAddress = organizationAddresses?.find((address: any) => {
              return address.OrganizationAddressTypes?.some((addressTypes: any) => addressTypes.Type === "Mailing");
            });

            if (mailAddress) {
              addressVariables.Id = mailAddress.Id;
            }

            client
              .mutate({
                mutation: mailAddress
                  ? UpdateOrganizationAddress
                  : CreateOrganizationAddress,
                variables: addressVariables,
              })
              .then(() => {
                client
                  .mutate({
                    mutation: CreatePartnerEnrollementAction,
                    variables: {
                      PartnerEnrollmentId: enrollmentId,
                      Name: "BusinessInformationCompleted",
                    },
                  })
                  .then(() => {
                    next();
                  })
              })
          })
          .catch((error: any) => {
            setShowSpinnerSubmit(false);
            console.log(error);
          });
      }
    }

    if (!alternativeAddress) {
      setShowSpinnerSubmit(true);
      client
        .query({
          query: GetOrganization,
          variables: { organizationId },
        })
        .then((res: any) => {
          const organizationData = res.data.GetOrganization;
          const organizationAddresses =
            res.data.GetOrganization.OrganizationAddresses;
          const addressVariables: any = {
            City: mailingAddress.city,
            OrganizationId: organizationData.Id,
            State: mailingAddress.state,
            StreetAddress1: mailingAddress.streetAddress1,
            OrganizationAddressTypes: [...mailingAddress.types,
            { Type: "Mailing" }
            ],
            ZipCode: mailingAddress.zipCode,
          };

          const mailAddress = organizationAddresses?.find(
            (address: any) => address.Id === mailingAddress.id
          );

          if (mailAddress) {
            addressVariables.Id = mailAddress.Id;
          }

          client
            .mutate({
              mutation: mailAddress
                ? UpdateOrganizationAddress
                : CreateOrganizationAddress,
              variables: addressVariables,
            })
            .then(() => {
              client
                .mutate({
                  mutation: CreatePartnerEnrollementAction,
                  variables: {
                    PartnerEnrollmentId: enrollmentId,
                    Name: "BusinessInformationCompleted",
                  },
                })
                .then(() => {
                  next();
                })
            })
        })
        .catch((error: any) => {
          console.log('error', error)
          setShowSpinnerSubmit(false);
        })
    }
  }

  return (
    <AnimatePresence mode="wait">
      <Container className="mt-3 mb-5">
        <Row className="justify-content-center">
          <Col md={10} className="content-box py-5  px-lg-5">
            <div className="mx-lg-5">
              <AppProgressBar progressPercent={progressPercent} />
              <motion.div key={showSpinner.toString()} {...motionContainer}>
                <h1 className="content-box-heading mb-4">
                  Default Mailing Address
                </h1>
                <h6 className="content-box-subtitle mb-3">
                  Please Specify The Default Mailing Address For Your Commission Check.
                </h6>
                <Row>
                  <Col lg={6} md={6} sm={6}>
                    {showSpinner ?
                      <Spinner as="span" animation="border" role="status" aria-hidden="true" className="mr-6" variant="primary" />
                      :
                      <Form.Select className="mb-3" onChange={onChangeUseAddress} name="useAddress" id="useAddress">
                        {addresses.map((address: any, index) => {
                          return (
                            <option key={index} value={address.OrganizationAddressTypes[0].Type}>{address.OrganizationAddressTypes[0].Type} - {address.StreetAddress1}</option>
                          )
                        })}
                        <option value="Mailing">New Address</option>
                      </Form.Select>
                    }
                  </Col>
                </Row>
                <Form>
                  {alternativeAddress &&
                    <>
                      <h6 className="content-box-subtitle mt-3 mb-3">Alternative Mailing Address</h6>
                      <Row className="mb-3">
                        <Col md={12} className="mb-3">
                          <label className="mb-2">
                            If your mailing address differs from the address(es) you have provided, please provide it below
                          </label>
                          <Form.Group controlId="streetAddress1">
                            <Form.Label>Street Address</Form.Label>
                            <Form.Control name="streetAddress1" onChange={onChangeAddress} value={mailingAddress.streetAddress1} type="text" placeholder="" />
                            {submited && formErrors.streetAddress1 && (
                              <Message message={formErrors.streetAddress1} type="error"></Message>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group controlId="streetAddress2">
                            <Form.Label>Street Address 2</Form.Label>
                            <Form.Control name="streetAddress2" onChange={onChangeAddress} value={mailingAddress.streetAddress2} type="text" placeholder="" />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md={5}>
                          <Form.Group controlId="city">
                            <Form.Label>City </Form.Label>
                            <Form.Control type="text" placeholder="" name="city" value={mailingAddress.city} onChange={onChangeAddress} />
                            {submited && formErrors.city && (
                              <Message message={formErrors.city} type="error"></Message>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={2}>
                          <Form.Group controlId="state">
                            <Form.Label>State</Form.Label>
                            <Form.Select name="state" onChange={onChangeAddress} value={mailingAddress.state}>
                              {StateOptions.map((state) => {
                                return <option key={state} value={state}>{state}</option>;
                              })}
                            </Form.Select>
                            {submited && formErrors.state && (
                              <Message message={formErrors.state} type="error"></Message>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group controlId="zipCode">
                            <Form.Label>ZIP Code</Form.Label>
                            <Form.Control type="text" placeholder="" name="zipCode" value={mailingAddress.zipCode} onChange={(e) => onChangeAddress(e)} />
                            {submited && formErrors.zipCode && (
                              <Message message={formErrors.zipCode} type="error"></Message>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  }
                </Form>
                <div className="d-flex justify-content-center mt-5 align-items-center">
                  <button disabled={showSpinner} onClick={onSubmit} className="btn-continue">
                    {showSpinnerSubmit && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mx-2" />}
                    Continue
                  </button>
                </div>
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>
    </AnimatePresence>
  );
}

export default PartnerDefaultMailingAddress;